import React from 'react';
import {
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubTrigger,
    DropdownMenuPortal,
    DropdownMenuSubContent
} from '../../ui/dropdown-menu';
import Entity from '../entity/Entity';
import Icon from '../icon/Icon';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 *
 * @param root0
 * @param root0.actions
 * @param root0.side
 * @param root0.align
 * @param root0.hasTooltip
 * @returns {JSX} DropdownContent
 */
function DropdownContent({ actions, side, align, hasTooltip = false }) {

    // Translate
    const { t: translate } = useTranslation();

    // Constants
    const visibleActions = actions.filter(action => action.visible);

    const renderActions = (action, index, showSeparator) => {
        const variantClassName = action.variant ? `text-${action.variant}` : 'text-primary';

        if (action.menuLabel) {
            return <DropdownMenuLabel key={index}>{action.menuLabel}</DropdownMenuLabel>;
        }

        return (
            <React.Fragment key={`${action.entity}-${index}`}>
                <DropdownMenuItem
                    data-cy={action.dataCy}
                    onClick={action.onClick}
                    disabled={action.disabled}
                    title={action.disabled ? translate(action.tooltipForbidden) : undefined}
                >
                    <Icon icon={action.icon} className={variantClassName} />
                    <Entity entity={action.entity} namespace={action.namespace} data={action.data} className={cn(action.variant ? variantClassName : '')} />
                </DropdownMenuItem>
                {showSeparator && <DropdownMenuSeparator />}
            </React.Fragment>

        );
    };

    return (
        <DropdownMenuContent
            onCloseAutoFocus={(e) => {
                if (hasTooltip) { e.preventDefault(); }
            }}
            className='dropdown'
            side={side}
            align={align}
            sideOffset={4}>
            {
                visibleActions.map((action, index) => {
                    const showSeparator = index < visibleActions.length - 1;

                    if (action.subActions) {
                        const visibleSubActions = action.subActions.filter(subAction => subAction.visible);

                        // Add submenu management
                        return (
                            <DropdownMenuSub key={`${action.trigger}-${index}`}>
                                <DropdownMenuSubTrigger>
                                    <Entity entity={action.trigger} namespace={action.namespace} />
                                </DropdownMenuSubTrigger>
                                {showSeparator && <DropdownMenuSeparator />}
                                <DropdownMenuPortal>
                                    <DropdownMenuSubContent>
                                        {
                                            visibleSubActions.map((subAction, subIndex) => {
                                                const showSubActionSeparator = subIndex < visibleSubActions.length - 1;

                                                return (
                                                    renderActions(subAction, subIndex, showSubActionSeparator)
                                                );
                                            })
                                        }
                                    </DropdownMenuSubContent>
                                </DropdownMenuPortal>
                            </DropdownMenuSub>
                        );
                    }
                    return renderActions(action, index, showSeparator);
                })
            }
        </DropdownMenuContent>
    );
}

DropdownContent.propTypes = {
    actions: PropTypes.array.isRequired,
    side: PropTypes.string,
    align: PropTypes.string,
    hasTooltip: PropTypes.bool
};

export default DropdownContent;